module.exports = __webpack_public_path__ + "static/media/pic_3.fd262384.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/pic_3.png
// module id = 523
// module chunks = 0